
import NavItems from '../Header/NavItems.json'
import { mapGetters } from 'vuex'
import CheckMobileApp from '~/mixins/CheckMobileApp'
export default {
  mixins: [CheckMobileApp],
  data() {
    return {
      navItems: NavItems,
      types: [],
      activeMenu: {
        type: null,
        items: [],
      },
      myProfile: [],
    }
  },
  watch: {
    $route: {
      handler() {
        this.activeMenu = {
          type: null,
          items: [],
        }
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      getActiveUser: 'user/getActiveUser',
    }),
  },
  methods: {
    DETECT_CLICK_OUTSIDE(e) {
      if (!e.target.closest('#mobile-navbar')) {
        this.activeMenu = {
          type: null,
          items: [],
        }
      }
    },
    setActiveMenu(type) {
      if (this.activeMenu.type === type) {
        return (this.activeMenu = {
          type: null,
          items: [],
        })
      }
      this.activeMenu = {
        type,
        items: this.navItems.find((item) => item.title === type).sub,
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.DETECT_CLICK_OUTSIDE)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.DETECT_CLICK_OUTSIDE)
  },
}
